module.exports = __webpack_public_path__ + "img/edit_map_control.0f2dbf29.svg";